// /// <reference path ="@scoped/core-libs/jquery/index.d.ts"/>


// import * as Sentry from '@sentry/browser';
// if (process.env.NODE_ENV === 'production') {
  // Sentry.init({dsn: 'https://cc2410e73eb04c53920340753f6ff764@sentry.io/1388759', environment: process.env.NODE_ENV});
// }

import "./scss/app.scss"


// import * as $ from '@scoped/core-libs/jquery';
// import 'jquery'

// let $         = require('jquery')
// global.$      = $;
// global.jQuery = $;


// import 'bootstrap';

// import 'popper.js'

// import 'bootstrap/js/dist/util';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/tab';

// // import 'bootstrap/js/dist/alert';
// // import 'bootstrap/js/dist/button';
// // import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/collapse';
// // import 'bootstrap/js/dist/popover';
// // import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// // import 'bootstrap/js/dist/tooltip';

import kzkWdgt from './js/player'
global.kzkWdgt = kzkWdgt;

let KIOSK = {}

import {trigger, on, one, off} from './js/util/event'
// KIOSK.on = util_event.on;
KIOSK.trigger = trigger;
KIOSK.on = on;
KIOSK.one = one;
KIOSK.off = off;

import {events} from './js/events'

KIOSK.events = events

import {
  modal,
  openModal,
  closeModal,
  reloadWindow,
  formSubmit,
  openSecondaryModal,
  closeSecondaryModal,
  modalResize,
} from './js/modal'

global.modalResize = modalResize;

KIOSK.modal               = modal;
KIOSK.openModal           = openModal;
KIOSK.closeModal          = closeModal;
KIOSK.reloadWindow        = reloadWindow;
KIOSK.formSubmit          = formSubmit;
KIOSK.openSecondaryModal  = openSecondaryModal;
KIOSK.closeSecondaryModal = closeSecondaryModal;

import main from './js/util/main'

KIOSK.main = main

import issue from './js/issue'
KIOSK.issue = issue

import article from './js/article'
KIOSK.article = article

import audioEpisode from './js/audioEpisode'
KIOSK.audioEpisode = audioEpisode

import feed from './js/feed'
KIOSK.feed = feed


import './js/pjax'

import urlParams from './js/util/urlParams';

KIOSK.urlParams = urlParams

import userInteresting from './js/userInteresting'

KIOSK.userInteresting = userInteresting

import userSubscription from './js/userSubscription'
KIOSK.userSubscription = userSubscription;

import userCategoryPresets from './js/userCategoryPresets'
KIOSK.userCategoryPresets = userCategoryPresets

import api from './js/api';
KIOSK.closeOldVersionNotification = function() {
  api.post('/api/v1/old-version-notification/event/close')
};

import analytics from './js/analytics';
KIOSK.analytics = analytics;

KIOSK.showMfSubscribeNotification = function() {
  api.post('/api/v1/show-mf-subscribe-notification').then((response) => {
    "use strict";
    const data     = response.data;
    if (data && data.path) {
      KIOSK.openModal(data.path, 0, true);
    }
  }, () => {
  })
};

if (KIOSK.modules === undefined) {
  KIOSK.modules = {};
}
if (KIOSK.modules.events === undefined) {
  KIOSK.modules.events = events;
}

export {KIOSK}
global.KIOSK = KIOSK

// import './stories/entry-client'


import Sidenav from './js/sidenav';



if ($('body > .wrapper').get(0)) {
  window.sidenav = new Sidenav({
    content: $('body > .wrapper').get(0),
    sidenav: $('.mobile-menu').get(0),
    backdrop: $('.mobile-menu-backdrop').get(0),
    sidenavSide: 'right',
    menuElement: document.querySelector('.mobile-menu')
  });

  const sidenav = window.sidenav;
}

import './js/carousel'

$('body')
  .on('click', '.navbar .search .search-btn', function() {
    var $parent       = $(this).closest('.search');
    var $search_input = $parent.find('.search-input');
    if ($parent.hasClass('out')) {
      $parent.removeClass('out').addClass('in');
      $search_input.focus();
    }
    else {
      if ($search_input.val().trim() !== '') {
        $parent.find('form').submit();
      }
      else {
        $parent.removeClass('in').addClass('out');
      }
    }
  })
  .on('submit', '.navbar .search form', function(e) {
    var $parent       = $(this).closest('.search');
    var $search_input = $parent.find('.search-input');
    if ($search_input.val().trim() === '') {
      $parent.removeClass('in').addClass('out');
      $search_input.blur();
      e.preventDefault();
    }
  })
  .on('click', '.navbar .search-out .search-btn', function() {
    var $parent       = $(this).closest('.search-out');
    var $search_input = $parent.find('.search-input');
    var $logo         = $('.navbar .navbar-header .navbar-brand');
    if ($parent.hasClass('out')) {
      $parent.removeClass('out').addClass('in');
      $logo.css('opacity', 0);
      $search_input.focus();
    }
    else {
      if ($search_input.val().trim() !== '') {
        $parent.find('form').submit();
      }
      else {
        $parent.removeClass('in').addClass('out');
        $logo.css('opacity', 1);
      }
    }
  })
  .on('submit', '.navbar .search-out form', function(e) {
    var $parent       = $(this).closest('.search-out');
    var $search_input = $parent.find('.search-input');
    var $logo         = $('.navbar .navbar-header');
    if ($search_input.val().trim() === '') {
      $parent.removeClass('in').addClass('out');
      $logo.css('opacity', 1);
      $search_input.blur();
      e.preventDefault();
    }
  })
  .on('click', '.add-to-fav', function(event) {
    event.preventDefault();
    var btn  = $(this);
    var url  = btn.attr('data-href');
    var icon = $('.fa', btn);
    icon.removeClass('fa-star').addClass('fa-repeat');
    $.get(url, function(result) {
      //noinspection JSUnresolvedVariable
      if (result.isFav) {
        btn.addClass('active');
      }
      else {
        btn.removeClass('active');
      }
      icon.removeClass('fa-repeat').addClass('fa-star');
    }, 'json');
  })

  .on('click', '.navbar-toggler', function() {
    sidenav.open();
  })
  .on('click', '.mobile-menu-item-closer button', function() {
    sidenav.close();
  })
  .on('click', '[data-toggle="search"]', function() {
    //sidenav.open();
    var body = $('body'), el = $(this);
    if (body.hasClass('search-open')) {
      body.removeClass('search-open');
      var backdrop = body.find('#search-modal-backdrop').removeClass('show');
      setTimeout(function() {
        backdrop.remove();
      }, 150)
    } else {
      body.addClass('search-open');

      var input = body.find('[name="q"]');
      input.focus();

      body.append('<div class="modal-backdrop search-modal-backdrop fade show" id="search-modal-backdrop"></div>').css('z-index');
    }
  })
  .on('keypress', '[data-mobile-next]', function(event) {
    if (event.charCode == 13 && /Android/.test(navigator.userAgent)) {
      event.preventDefault();
      var next = $(this).data('mobile-next');
      $(next).focus();
    }
  }).on('click', '.lang-links .nav-link', function(e) {
    var lang = $(e.currentTarget).data('lang');
    if (lang) {
      e.stopPropagation();
      e.preventDefault();
      var href = window.location.href;
      href = href.replace(/(&|\?)?hl=([^&]$|[^&]*)/i, '');
      var glue = '?';
      if (href.indexOf('?') >= 0) {
        glue = '&';
      }
      window.location.href=href+glue+'hl='+lang;
    }

  })


// $('.search-input').autocomplete({
//   serviceUrl: '/autocomplete/search',
//   dataType: 'json',
//   paramName: 'query',
//   deferRequestBy: 300/*,
//         onSelect: function (e) {
//             $(this).parents('form').submit();
//         }*/
// });


KIOSK.clickAppBtnIntent = function(e) {

  if (e) {
    e.preventDefault(), e.stopPropagation()
  }

  // ga('main.send', 'event', 'ToApp', 'click', 'ToAppButtonClick') - нажатие
  // ga('main.send', 'event', 'ToApp', 'show', 'ToAppButtonShow') - показ


    // trigger event
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'ToApp',
    eventAction: 'click',
    eventLabel: 'ToAppButtonClick',
    transport: 'beacon'
  });


  api.get('/api/v1/app-button-intent').then((response) => {
    "use strict";
    // const data     = response.data;


    if (data && data.path) {
      window.location.href = data.path;
    }
  }, () => {
  })
};
